import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { AuthenticationService } from "src/app/_services/authentication.service";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"],
})
export class ChangePasswordFormComponent implements OnInit {
  loading = false;
  errorMessage: string;
  successMessage: string;
  changePasswordForm = new FormGroup({
    oldPassword: new FormControl("", [Validators.required]),
    newPassword: new FormControl("", [
      Validators.required,
      Validators.minLength(8),
    ]),
    confirmPassword: new FormControl("", [
      Validators.required,
      Validators.minLength(8),
    ]),
  });

  constructor(private authService: AuthenticationService) {}
  ngOnInit() {}

  onSubmit() {
    this.loading = true;
    this.errorMessage = "";
    this.successMessage = "";
    this.authService
      .change_password({
        old_password: this.oldPassword.value,
        new_password: this.newPassword.value,
      })
      .subscribe(
        (res) => {
          this.successMessage = res.message;
          this.loading = false;
          this.changePasswordForm.reset();
        },
        (errRes) => {
          const { error, message } = errRes.error;
          this.loading = false;
          this.errorMessage = message || error;
        }
      );
  }
  get oldPassword() {
    return this.changePasswordForm.get("oldPassword");
  }

  get newPassword() {
    return this.changePasswordForm.get("newPassword");
  }

  get confirmPassword() {
    return this.changePasswordForm.get("confirmPassword");
  }

  passwordMatch() {
    if (
      this.newPassword.valid &&
      this.confirmPassword.value !== "" &&
      this.newPassword.value !== this.confirmPassword.value
    ) {
      return false;
    }
    return true;
  }
}
